/* unplugin-vue-components disabled */import script from "./GiftBgDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftBgDialog.vue?vue&type=script&setup=true&lang=js"

import "./GiftBgDialog.vue?vue&type=style&index=0&id=767c91de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-767c91de"]])

export default __exports__